import { IFileFormCreateRequest } from '@file/file.models';
import {
  ICreateInfoAttachedRequest,
  IProjectDesignBriefInfoAttached,
} from '@designBrief/infoAttached/infoAttached.models';
import { IProjectUserProfile } from '@userProfile/projectUserProfile.models';
import { IProjectFileBase, ITempProjectFile } from '@file/projectFile/projectFile.models';
import { IProjectCompanyOption } from '@company/projectCompany/projectCompany.models';

interface IUpsertDesignBriefBaseRequest {
  projectMasterScheduleId: number;
  projectId: number;
  briefDescription: string;
  carryOutDesignerCompany: string;
  carryOutDesignerCompanyId: number;
  informationAttached: ICreateInfoAttachedRequest[];
}

export interface ICreateDesignBriefRequest extends IUpsertDesignBriefBaseRequest {
  attachments: IFileFormCreateRequest[];
}
export interface IUpdateDesignBriefRequest extends IUpsertDesignBriefBaseRequest {
  id: number;
  rowVersion: string;
}

export interface IGetDesignBriefRevisionsRequest {
  id: number;
  projectId: number;
}

export interface ICreateDesignBriefRevisionRequest {
  id: number;
  projectMasterScheduleId: number;
  projectId: number;
}

export interface IDesignBrief {
  infoAttached: IProjectDesignBriefInfoAttached[];
  initiatedProjectUserProfile?: IProjectUserProfile;
  issuedProjectUserProfile: IProjectUserProfile;
  receivedDesignerProjectUserProfile?: IProjectUserProfile;
  receivedTwcProjectUserProfile?: IProjectUserProfile;
  id: number;
  projectMasterScheduleId: number;
  projectId: number;
  designBriefNo: string;
  briefDescription: string;
  initiatedProjectUserProfileId?: number;
  initiatedDate?: Date;
  issuedProjectUserProfileId: number;
  issuedDate?: Date;
  receivedDesignerProjectUserProfileId?: number;
  receivedDesignerDate?: Date;
  receivedTwcProjectUserProfileId?: number;
  receivedTwcDate?: Date;
  isSectionHeadReceived: boolean;
  isDesigneReceived?: boolean;
  isTwcReceived?: boolean;
  status: string;
  isDesignerClosed?: boolean;
  isIceAction?: boolean;
  isTwcAction?: boolean;
  afterClosedStatus?: string;
  targetDate?: Date;
  remark?: string;
  carryOutDesign: boolean;
  carryOutDesignerCompany: string;
  carryOutDesignerCompanyId: number;
  designerRemark?: string;
  originalDesignBriefId: number;
  nextRevisionDesignBriefId?: number;
  rowVersion: string;
  attachments?: IProjectFileBase[];
}

export enum EDesignBriefInfoAttachedFormKeys {
  ID = 'id',
  PROJECT_DESIGN_BRIEF_ID = 'projectDesignBriefId',
  DESIGN_BRIEF_INFO_ATTACHED_ID = 'designBriefInfoAttachedId',
  PROJECT_ID = 'projectId',
  NAME = 'name',
  PROVIDED = 'itemSelected',
  REMARK = 'remark',
  ROW_VERSION = 'rowVersion',
}

export enum EDesignBriefFormKeys {
  RISK_CATEGORY = 'riskCategory',
  DESIGNER = 'designer',
  DESC_OF_WORKS_TO_BE_DESIGNED = 'briefDescription',
  INFO_ATTACHED = 'informationAttached',
  FILES = 'attachments',
  SUPPLEMENTARY_FILES = 'supplementaryFiles',
}
export interface IDesignBriefFormState {
  [EDesignBriefFormKeys.RISK_CATEGORY]: string | null;
  [EDesignBriefFormKeys.DESIGNER]: IProjectCompanyOption | null;
  [EDesignBriefFormKeys.DESC_OF_WORKS_TO_BE_DESIGNED]: string | null;
  [EDesignBriefFormKeys.INFO_ATTACHED]: IProjectDesignBriefInfoAttached[];
  [EDesignBriefFormKeys.FILES]: ITempProjectFile[] | IProjectFileBase[];
  [EDesignBriefFormKeys.SUPPLEMENTARY_FILES]: ITempProjectFile[];
}

export const DesignBriefDetailButtonActionSave = 'Save';
export const DesignBriefDetailButtonActionIssueToTwc = 'Issue To Twc';
export const DesignBriefDetailButtonActionIssueToTwd = 'Issue To Twd';

export type DesignBriefDetailButtonAction =
  | typeof DesignBriefDetailButtonActionSave
  | typeof DesignBriefDetailButtonActionIssueToTwc
  | typeof DesignBriefDetailButtonActionIssueToTwd;
